<script setup>
import Loading from '@/components/loading.vue';
import emptyCard from '@/components/emptyCard.vue';
import { get_packages, get_trait } from '@/services/option';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { get_materials_filter, get_materials, delete_material } from '@/services/materials';
import { swalError } from '@/helper';

const isLoading = ref(true)
const current = ref({
  isOpen: false,
  package_id: ''
})
const packages_config = ref([])
const modules = ref([])
onMounted(async ()=>{
  let modulesReponse = await get_materials('modules')
  modules.value = modulesReponse.result.data.data.map(item => ({...item, traits: []}))
  await parseTraits(modulesReponse.result.data.included)
  await getPackages()
  isLoading.value = false
})

async function parseTraits(included){
  await Promise.all(included.map(async(item) => {
    if (item.attributes.object_type == 'trait'){
      let response = await get_trait(item.attributes.object_id)
      let singleModule = modules.value.find(tempModule => parseInt(tempModule.id) == item.attributes.material_id)
      singleModule.traits.push({...item, data: {...response.result.data}})
    }
  }))
  console.log(modules.value)
}

const packageConfig = ref([])
async function getPackages(){
  let response = await get_packages()
  if (response.error){
    swalError(response.result.error, true)
    return
  }
  packageConfig.value = [
    ...response.result.map(item=>({
      id: item.id,
      label: item.options.name.value,
      active: false
    }))
  ]
}

const route = useRoute()
const isDeleting = ref(false)
async function deleteModule(item_id){
  isDeleting.value = true
  let index = modules.value.findIndex(item => item.id == item_id)
  let response = await delete_material(item_id)
  modules.value.splice(index, 1)
  isDeleting.value = false
  if (response.error){
    swalError("Module couldn't be deleted")
  }else{
    Swal.fire({
      title: 'Deleted',
      text: "Module has been deleted",
      icon: 'success'
    })
  }
}

const currentFilter = ref({})
async function filterModule(packager){
  currentFilter.value = packager
  let params = {
    type: 'module',
    package: packager.id
  }
  let response = await get_materials_filter(params) 
  if (response.error){
    swalError(response.result.error)
    return
  }
  modules.value = [
    ...response.result.data.data.map(item => ({...item, traits: []}))
  ]
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Modules" />
    <Loading v-if="isLoading" />
    <div v-else class="row" v-auto-animate>
      <div v-auto-animate :class="{'col-12' : !current.isOpen, 'col-4': current.isOpen}">
        <div class="card">
          <div class="card-body">
            <!-- search bar -->
            <div class="d-flex my-2 mb-4 justify-content-end">
              <router-link :to="{name: 'new-material'}"
                class="btn btn-primary"
              >
                Add New Module
              </router-link>

              <div class="ms-2 search-input-wrapper">
                <form class="search-form">
                  <div class="input-group m-0 flex-nowrap">
                    <input class="form-control-plaintext py-1 ps-3 border-start" type="search" placeholder="Search Module">
                    <button class="btn btn-primary input-group-text text-white">Search</button>
                  </div>
                </form>
              </div>
            </div>

            <div class="d-flex my-2 mb-4">
              <template v-for="item in packageConfig" :key="item.id">
                <button class="btn btn-light-primary me-2 rounded-pill" 
                  :class="currentFilter.id == item.id ? 'active' : ''"
                  @click="filterModule(item)"
                >
                  {{ item.label }}
                </button>
              </template>
            </div>
            

            <!-- content -->
            <div class="card shadow-none border">
              <div class="card-body p-0 table-responsive">
                <table class="table user-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Traits</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr v-for="item in modules" :key="item.id">
                      <!-- title -->
                      <td>
                        {{item.attributes.name}}
                      </td>
                      <!-- traits  -->
                      <td>
                        <div class="d-flex">
                          <template v-if="item.traits.length >= 3">
                            <small v-for="i in 3" :key="i" class="ms-1 trait-pill rounded-pill">
                              {{ item.traits[i-1].data.attributes.name }}
                            </small>

                            <small v-if="item.traits.length - 3 != 0" class="ms-1 trait-pill rounded-pill">
                              {{ item.traits.length - 3 }} more..
                            </small>
                          </template>
                          <template v-else>
                            <small v-for="trait in item.traits" class="ms-1 trait-pill rounded-pill">
                              {{ trait.data.attributes.name }}
                            </small>
                          </template>
                        </div>
                      </td>
                      <!-- action button -->
                      <td class="text-center">
                        <router-link class="btn btn-primary" :to="{name: 'edit-material', params: {id: item.id}}">
                          Edit
                        </router-link>
                        <button @click="deleteModule(item.id)" class="ms-2 btn btn-danger"

                        >
                          <div v-if="isDeleting" class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Deleting...</span>
                          </div>
                          <span v-else>
                            Delete
                          </span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <template v-if="modules.length == 0">
                  <div class="text-center">
                    <p>No modules has been added yet</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>


        <emptyCard v-show="false" :link="{
            routerObj:{
              name: 'dna-report-report'
            },
            desc: 'Create a package',
            class: 'w-50',
            type: 'link'
          }"
        />
      </div>
    </div>
  </div>
</template>